export default __webpack_public_path__ + "static/media/Screenshot (24).4f15a3cb.png";